import { render, staticRenderFns } from "./pnldim1.vue?vue&type=template&id=4e0cd3e2"
import script from "./pnldim1.vue?vue&type=script&lang=js"
export * from "./pnldim1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports